import _implicitStylesheets from "./comment.css";
import _implicitScopedStylesheets from "./comment.scoped.css?scoped=true";
import _wdsAvatar from "wds/avatar";
import _wdsLink from "wds/link";
import _wdsBadge from "wds/badge";
import _axBadge from "ax/badge";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="comment-header${0}"${2}><span type-style="body-2" class="bolded${0}"${2}>${"t2"}</span></div>`;
const $fragment2 = parseFragment`<span type-style="body-3" class="right-align${0}"${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<div${3}><p type-style="body-3"${3}>${"t2"}</p></div>`;
const stc0 = {
  "comment-container": true
};
const stc1 = {
  classMap: {
    "header-container": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "flex-container": true,
    "comment-sub-container": true
  },
  key: 2
};
const stc3 = {
  key: 3
};
const stc4 = {
  "left-spacing": true
};
const stc5 = {
  classMap: {
    "flex-container": true
  },
  key: 9
};
const stc6 = {
  classMap: {
    "badge-container": true
  },
  key: 10
};
const stc7 = {
  classMap: {
    "flex-container": true
  },
  key: 15
};
const stc8 = {
  classMap: {
    "badge-container": true
  },
  key: 16
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, fid: api_scoped_frag_id, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, i: api_iterator} = $api;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "id": api_scoped_id($cmp.generatedId)
    },
    key: 0
  }, [api_element("div", stc1, [api_element("div", stc2, [$cmp.hasProfileLink ? api_custom_element("wds-link", _wdsLink, stc3, [api_element("a", {
    attrs: {
      "href": api_scoped_frag_id($cmp.comment.user.profileLink),
      "target": "_blank",
      "aria-label": $cmp.avatarLinkAriaLabel
    },
    key: 4
  }, [api_custom_element("wds-avatar", _wdsAvatar, {
    props: {
      "src": $cmp.comment.user.avatar
    },
    key: 5
  })])]) : null, !$cmp.hasProfileLink ? api_custom_element("wds-avatar", _wdsAvatar, {
    classMap: stc4,
    props: {
      "src": $cmp.comment.user.avatar,
      "alt": $cmp.defaultAvatarAltText
    },
    key: 6
  }) : null, api_static_fragment($fragment1, 8, [api_static_part(2, null, api_dynamic_text($cmp.commentUserName))]), !$cmp.isMobile ? api_element("div", stc5, [api_element("div", stc6, api_iterator($cmp.comment.user.badges, function (badge) {
    return [badge.i18nFn ? api_custom_element("wds-badge", _wdsBadge, {
      props: {
        "badge": badge
      },
      key: api_key(11, badge.iteratorKey)
    }) : null, !badge.i18nFn ? api_custom_element("ax-badge", _axBadge, {
      props: {
        "text": badge.value,
        "theme": badge.variant
      },
      key: api_key(12, badge.iteratorKey)
    }) : null];
  }))]) : null, api_static_fragment($fragment2, 14, [api_static_part(1, null, api_dynamic_text($cmp.comment.date))])]), $cmp.isMobile ? api_element("div", stc7, [api_element("div", stc8, api_iterator($cmp.comment.user.badges, function (badge) {
    return [badge.i18nFn ? api_custom_element("wds-badge", _wdsBadge, {
      props: {
        "badge": badge
      },
      key: api_key(17, badge.iteratorKey)
    }) : null, !badge.i18nFn ? api_custom_element("ax-badge", _axBadge, {
      props: {
        "text": badge.value,
        "theme": badge.variant
      },
      key: api_key(18, badge.iteratorKey)
    }) : null];
  }))]) : null]), api_static_fragment($fragment3, 20, [api_static_part(2, null, api_dynamic_text($cmp.comment.content))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7vmvi4og0nu";
tmpl.legacyStylesheetToken = "undefined-_comment";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
